import React, { Component } from 'react'
import DefaultLayout from '../../Layout/Default'
import Box from '../../../Shared/Box'
import { Col, Container, Row } from '../../../Shared/Grid'
import Input from '../../../Shared/Form/Input'
import Button from '../../../Shared/Form/Button'
import './styles.scss'
import Select from '../../../Shared/Form/Select'
import Loader from '../../../Shared/Loader'
import { adminOrderActions } from '../../../../redux/actions/admin/admin-orders'
import { Link } from 'react-router-dom'
import Pagination from '../../../Shared/Pagination'
import Icon from '../../../Shared/Icon'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Alert from '../../../Shared/Alert'
import dayjs from 'dayjs'
import SubscriptionItemList from './SubscriptionItemList'

class OrdersPage extends Component {

  constructor (props) {
    super(props)
    this.state = {
      searchOptions: {
        filter: {
          id: '',
          workflowStatus: -1,
          giataId: '',
          email: ''
        },
        pagination: {
          offset: 0,
          limit: 50
        }
      },
      collapsedAll: true,
      showAdditionalInformationForOrderIds: {}
    }
  }

  componentDidMount () {
    this.searchNew()
  }

  getWorkflowStatusOptions () {
    const { t } = this.props
    return [
      { label: t('ALL'), value: -1 },
      { label: t('ORDER_WORKFLOW_STATUS_UNPROCESSED'), value: 0 },
      { label: t('ORDER_WORKFLOW_STATUS_PROCESSED'), value: 1 },
    ]
  }

  searchNew () {
    let searchOptions = {
      filter: { ...this.state.searchOptions.filter },
      pagination: { ...this.state.searchOptions.pagination },
      collapsedAll: true
    }
    searchOptions.pagination.offset = 0
    this.setState({
      searchOptions
    }, () => {
      this.search()
    })
  }

  search = () => {
    let searchOptions = {
      filter: { ...this.state.searchOptions.filter },
      pagination: { ...this.state.searchOptions.pagination }
    }
    for (let key of Object.keys(searchOptions.filter)) {
      if (searchOptions.filter[key] === '') {
        delete searchOptions.filter[key]
      }
    }
    if (searchOptions.filter.workflowStatus === -1) {
      delete searchOptions.filter.workflowStatus
    }
    if (searchOptions.filter.hasOwnProperty('giataId')) {
      searchOptions.filter.giataId = parseInt(searchOptions.filter.giataId, 10)
    }
    if (searchOptions.filter.hasOwnProperty('id')) {
      searchOptions.filter.id = parseInt(searchOptions.filter.id, 10)
    }
    this.setState({ showAdditionalInformationForOrderIds: {} }, () => {
      this.props.searchOrders(searchOptions)
    })
  }

  handleSubmit (e) {
    e.preventDefault()
    this.searchNew()
  }

  onSearchFilterChange (event, name) {
    let searchOptions = {
      filter: { ...this.state.searchOptions.filter },
      pagination: { ...this.state.searchOptions.pagination }
    }
    let value = event.target.value
    if (name === 'workflowStatus') {
      value = parseInt(value, 10)
    }
    searchOptions.filter[name] = value
    this.setState({ searchOptions: searchOptions })
  }

  getOrderStatus (status) {
    switch (status) {
      case 0:
        return this.props.t('ORDER_WORKFLOW_STATUS_UNPROCESSED')
      case 1:
        return this.props.t('ORDER_WORKFLOW_STATUS_PROCESSED')
      default:
        return '-'
    }
  }

  collapse (collapse) {
    if (collapse) {
      this.setState({
        collapsedAll: collapse,
        showAdditionalInformationForOrderIds: {}
      })
    } else {
      let showAdditionalInformationForOrderIds = {}
      for (const order of this.props.adminOrders.orders) {
        showAdditionalInformationForOrderIds[order.id] = 1
      }
      this.setState({
        collapsedAll: collapse,
        showAdditionalInformationForOrderIds: showAdditionalInformationForOrderIds
      })
    }
  }

  toggleOrderInformation = (orderId) => {
    let showAdditionalInformationForOrderIds = { ...this.state.showAdditionalInformationForOrderIds }
    if (showAdditionalInformationForOrderIds.hasOwnProperty(orderId)) {
      delete showAdditionalInformationForOrderIds[orderId]
    } else {
      showAdditionalInformationForOrderIds[orderId] = 1
    }
    this.setState({
      showAdditionalInformationForOrderIds: showAdditionalInformationForOrderIds
    })
  }
  onPaginationChange = (page) => {
    let searchOptions = { ...this.state.searchOptions }
    searchOptions.pagination.offset = Pagination.calculateOffset(page, this.state.searchOptions.pagination.limit)
    this.setState({
      searchOptions
    }, () => {
      this.search()
    })
  }

  createResultRow (order) {
    const orderStatusString = this.getOrderStatus(order.workflowStatus)
    const { t } = this.props

    const showAdditionalInformation = this.state.showAdditionalInformationForOrderIds.hasOwnProperty(order.id)
    return (
      <React.Fragment key={order.id}>
        <tr onClick={() => {this.toggleOrderInformation(order.id)}} style={{ cursor: 'pointer' }}>
          <td data-title={t('ORDER_ID')}>{order.id}</td>
          <td data-title={t('EMAIL')}>{order.customer.email}</td>
          <td
            data-title={t('ORDER_DATE')}>{order.createdAt ? dayjs(order.createdAt).locale(this.props.i18n.language).format('L LT') : '-'}</td>
          <td data-title={t('ORDER_STATUS')}>{orderStatusString}</td>
          <td>
            <span className={'clearfix'} style={{ float: 'right', display: 'flex', alignItems: 'flex-end' }}>
            <Link to={'/admin/orders/' + order.id}>
              <i style={{ fontSize: '16.8px' }} className="fa fa-edit" aria-hidden="true"/>
            </Link>
            <span style={{ marginLeft: '5px' }} onClick={() => {this.toggleOrderInformation(order.id)}}><Icon
              type={showAdditionalInformation ? 'arrow-blue-up' : 'arrow-blue-dn'}/></span>
            </span>
          </td>
        </tr>
        {showAdditionalInformation ?
          <tr className={'order-details'}>
            <td colSpan={6}>
              <div>
                <SubscriptionItemList subscriptionId={order.id}/>
              </div>
            </td>
          </tr>
          : null}
      </React.Fragment>
    )
  }

  render () {
    const { t } = this.props
    let tbodyContent
    if (this.props.adminOrders.total === 0) {
      tbodyContent = <tr>
        <td colSpan={8}>{t('NO_RESULTS_TO_SEARCH_FOUND')}</td>
      </tr>
    } else {
      tbodyContent = this.props.adminOrders.orders.map(order => this.createResultRow(order))
    }

    const currentPage = Pagination.calculatePage(this.state.searchOptions.pagination.offset, this.state.searchOptions.pagination.limit)
    return (
      <DefaultLayout>
        <div className="ordersPage">
          <Box style={{ position: 'relative' }} hasInnerBackground={true}>
            <Container fluid gutterWidth={5}>
              {this.props.adminOrders.loadingOrders ? <Loader size={32}/> : null}
              <Row>
                <Col xs={12}>
                  <h3>{t('SEARCH')}</h3>
                </Col>
              </Row>
              <form onSubmit={(event) => this.handleSubmit(event)}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={3}>
                    <Input onChange={(event) => {this.onSearchFilterChange(event, 'id')}}
                           value={this.state.searchOptions.filter.id}
                           type={'number'}
                           label={t('ORDER_ID')}/>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={3}>
                    <Input onChange={(event) => {this.onSearchFilterChange(event, 'email')}}
                           value={this.state.searchOptions.filter.email}
                           type={'email'}
                           label={'Email'}/>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={3}>
                    <Input onChange={(event) => {this.onSearchFilterChange(event, 'giataId')}}
                           value={this.state.searchOptions.filter.giataId}
                           type={'number'}
                           label={'GIATA-ID'}/>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={3}>
                    <Select onChange={(event) => {this.onSearchFilterChange(event, 'workflowStatus')}}
                            options={this.getWorkflowStatusOptions()}
                            selected={this.state.searchOptions.filter.workflowStatus} label={'Status'}/>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Button align="right" type={'submit'}>{t('SEARCH')}</Button>
                  </Col>
                </Row>
              </form>
              <Row>
                <Container style={{ flex: 1 }} fluid gutterWidth={5}>
                  <Row style={{ marginTop: '15px' }}>
                    <Col xs={12} style={{ display: 'flex' }}>
                      <h3>{t('ORDERS')}</h3>
                      {this.props.adminOrders.total > 0 ? <Button align="right"
                                                                  style={{ margin: '0 0 0 auto' }}
                                                                  onClick={() => this.collapse(!this.state.collapsedAll)}>{this.state.collapsedAll ? t('EXPAND_ALL') : t('COLLAPSE_ALL')}</Button>
                        : null}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <div className="flex-table" style={{ flex: 1 }}>
                        <div style={{ position: 'relative' }} className="table-responsive-vertical">
                          {this.state.loadingPrices ? <Loader size={30}/> : null}
                          {this.props.adminOrders.error ? <Alert type={'danger'}>Failed to get orders</Alert> : null}
                          <table className="table table-hover table-mc-light-blue Gradient">
                            <thead>
                            <tr>
                              <td>{t('ORDER_ID')}</td>
                              <td>{t('EMAIL')}</td>
                              <td>{t('ORDER_DATE')}</td>
                              <td>{t('ORDER_STATUS')}</td>
                              <td/>
                            </tr>
                            </thead>
                            <tbody>
                            {tbodyContent}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Row>
              <Row>
                <Pagination style={{ marginLeft: 'auto' }} current={currentPage} total={this.props.adminOrders.total}
                            pageSize={this.state.searchOptions.pagination.limit}
                            onChange={this.onPaginationChange}/>
              </Row>
            </Container>
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    adminOrders: state.adminOrders
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    searchOrders: (searchOptions) => dispatch(adminOrderActions.searchOrders(searchOptions))
  }
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrdersPage))
